export default import.meta.ROLLUP_FILE_URL_CE_Wm4Gx;